import { render, staticRenderFns } from "./ModalOrganEdit.vue?vue&type=template&id=db13b15a&scoped=true"
import script from "./ModalOrganEdit.vue?vue&type=script&lang=js"
export * from "./ModalOrganEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalOrganEdit.vue?vue&type=style&index=0&id=db13b15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db13b15a",
  null
  
)

export default component.exports